import React, { useState, useEffect } from "react";
import { sbGetSetting, sbSetSetting } from "../utils/supabaseClient";
import "../styles/ListTab.css";

const ResourceListTab = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    loadResources();
  }, []);

  const loadResources = async () => {
    try {
      setLoading(true);
      const data = await sbGetSetting("origamic-resources");
      const sorted = Array.isArray(data)
        ? [...data].sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt))
        : [];
      setResources(sorted);
    } catch (err) {
      console.error("Error loading resources:", err);
      alert("Failed to load resources");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this resource?"))
      return;

    try {
      const updated = resources.filter((r) => r.id !== id);
      await sbSetSetting("origamic-resources", updated);
      setResources(updated);
      alert("Resource deleted successfully!");
    } catch (err) {
      console.error("Error deleting resource:", err);
      alert("Failed to delete resource");
    }
  };

  const handleEdit = (resource) => {
    setEditingId(resource.id);
    setEditFormData({ ...resource });
  };

  const handleSaveEdit = async () => {
    try {
      const updated = resources.map((r) =>
        r.id === editingId ? editFormData : r
      );
      await sbSetSetting("origamic-resources", updated);
      setResources(updated);
      setEditingId(null);
      alert("Resource updated successfully!");
    } catch (err) {
      console.error("Error saving resource:", err);
      alert("Failed to save resource");
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditFormData({});
  };

  if (loading) return <div className="loading">Loading resources...</div>;

  if (resources.length === 0)
    return (
      <div className="empty-state">No resources found. Create one first!</div>
    );

  return (
    <div className="list-container">
      <h2>All Resources ({resources.length})</h2>

      {editingId ? (
        // Edit Form
        <div className="edit-form">
          <h3>Edit Resource</h3>
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              value={editFormData.title || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, title: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              value={editFormData.category || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, category: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>URL</label>
            <input
              type="url"
              value={editFormData.url || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, url: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              value={editFormData.description || ""}
              onChange={(e) =>
                setEditFormData({
                  ...editFormData,
                  description: e.target.value,
                })
              }
              rows="4"
            />
          </div>
          <div className="form-actions">
            <button className="btn-save" onClick={handleSaveEdit}>
              💾 Save Changes
            </button>
            <button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        // Resources List
        <div className="items-grid">
          {resources.map((resource) => (
            <div key={resource.id} className="item-card">
              <div className="item-content">
                <h4>{resource.title}</h4>
                {resource.category && (
                  <p className="item-meta">Category: {resource.category}</p>
                )}
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="item-link"
                >
                  🔗 {resource.url}
                </a>
                {resource.description && (
                  <p className="item-preview">{resource.description}</p>
                )}
              </div>
              <div className="item-actions">
                <button
                  className="btn-edit"
                  onClick={() => handleEdit(resource)}
                >
                  ✏️
                </button>
                <button
                  className="btn-delete"
                  onClick={() => handleDelete(resource.id)}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResourceListTab;
